export const articlesTypes = {
  LETS_GO_CLICK: 'LETS_GO_CLICK',
  PUBLISH_CLICK: 'PUBLISH_CLICK',
  REQUEST: 'USER_ARTICLES_REQUEST',
  SUCCESS: 'USER_ARTICLES_SUCCESS',
  FAILED: 'USER_ARTICLES_FAILED',
  SET_CURRENT_DRAFT: 'USER_ARTICLES_CURRENT_DRAFT_UPDATED',
  REQUEST_BY_ID: 'USER_ARTICLES_BY_ID_REQUEST',
  SUCCESS_BY_ID: 'USER_ARTICLES_BY_ID_SUCCESS',
  FAILED_BY_ID: 'USER_ARTICLES_BY_ID_FAILED',
  RESET_CURRENT: 'RESET_CURRENT_ARTICLE',
};
export const otherUserArticlesTypes = {
  REQUEST: 'OTHER_USER_ARTICLES_REQUEST',
  SUCCESS: 'OTHER_USER_ARTICLES_SUCCESS',
  FAILED: 'OTHER_USER_ARTICLES_FAILED',
};
export const createArticleTypes = {
  REQUEST: 'CREATE_ARTICLE_REQUEST',
  SUCCESS: 'CREATE_ARTICLE_SUCCESS',
  FAILED: 'CREATE_ARTICLE_FAILED',
};
export const updateArticleTypes = {
  REQUEST: 'UPDATE_ARTICLE_REQUEST',
  SUCCESS: 'UPDATE_ARTICLE_SUCCESS',
  FAILED: 'UPDATE_ARTICLE_FAILED',
};
export const autoSaveArticleTypes = {
  REQUEST: 'AUTO_SAVE_ARTICLE_REQUEST',
  SUCCESS: 'AUTO_SAVE_ARTICLE_SUCCESS',
  FAILED: 'AUTO_SAVE_ARTICLE_FAILED',
};
